import axios from 'axios';

/**
 * get list
 */
export const getArticleList = data => axios.$callAPI(() => axios.get('articles/search', { params: data }));

/**
 * update pic
 */
export const updatePic = pic => axios.$callAPI(() => axios.get('articles/search', pic));

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('articles/', data));

/**
 * del
 */
export const del = id => axios.$callAPI(() => axios.delete('articles/' + id));
/**
 * del all
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('articles/', { data: ids }));
/**
 * get ArticleInfo
 */
export const getArticleInfo = id => axios.$callAPI(() => axios.get('/articles/' + id));

/**
 * get imageSizeInfo
 */
export const getImageSizeInfo = () => axios.$callAPI(() => axios.get('/articles/imageSize'));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('articles/' + id, data));

export const getArticleHistoryList = data => axios.$callAPI(() => axios.get('harticles/search', { params: data }));

export const getArticleHistory = id => axios.$callAPI(() => axios.get('/harticles/' + id));
